export default {
  navigation: {
    home: '首页',
    compatible: '兼容性',
    question: '故障排查',
    feedback: '问题反馈',
    product: '产品展示',
    course: '更换视频教程',
    goBack: '返回首页',
    en: '英文',
    cn: '中文',
    menu: '菜单',
    switchLanguage: '切换语言',
  },
  home: {
    title: 'SHOKZ 展架用户指南',
    desc: '为您的产品展示架提供完整的使用指南、安装教程和技术支持',
    videoTitle: 'POP3.5 系列配件更换视频教程',
    videoTitleOpenDots2: 'OpenDots 2系列更换视频教程',
    productListTitle: 'POP3.5 系列展架',
    productListDesc: '支持OpenFit Pro等新产品新增功能，在POP3.0基础上进行优化，支持模块化变更。',
    newTag: '新品推荐',
    productListTitle2: '标准系列展架',
    classicTag: '经典系列',
    classicDesc: '成熟的展架产品线，适用于大多数SHOKZ耳机型号，稳定可靠'
  },
  product: {
    installWarning: '如遇到安装困难，请参考随附的视频教程或联系我们的技术支持团队。',
    standardDisplay: '标准展架',
    standardSeriesDisplay: '标准系列展架',
    multiProductDisplay: '多产品桌面展架',
    cabinetDisplay: '柜式展架',
    hangingDisplay: '挂式标准展架',
    hangingCombinationDisplay: '挂式组合展架',
    tankDisplay: '水箱展架',
    displayDesc: '展架介绍',
    installDesc: '如何安装',
    replaceDesc: '如何替换',
    backToList: '返回展架列表',
    productDesc: '产品介绍',
    productDisplay: '产品展示',
    techSpec: '技术规格',
    dimension: '尺寸',
    netWeight: '净重',
    grossWeight: '毛重',
    packageDimension: '带包装尺寸',
    material: '材料',
    applicableScene: '适用场景',
    compatibleProduct: '兼容产品',
    compatibleProductDesc: '以下产品可在 OpenFit Pro 标准展架上展示：',
    installGuide: '安装指南',
    installGuideDesc: '请按照以下步骤正确安装您的展示架。安装前请确保工作区域干净整洁，并有足够的空间进行操作。',
    installMaterial: '安装素材',
    installVideo: '安装视频',
    installVideoDesc: '观看详细的安装视频教程',
    installVideoBtn: '观看视频',
    installManual: '安装手册',
    installManualDesc: '下载详细的安装说明PDF文档',
    installManualBtn: '下载pdf',
    installManualImg: '安装示意图',
    installManualImgDesc: '查看安装步骤的示意图',
    installManualImgBtn: '查看大图',
    prepareWork: '准备工作',
    prepareWorkDesc1: '检查包装内的所有配件是否齐全',
    prepareWorkDesc2: '准备安装工具（通常包含在包装内）',
    prepareWorkDesc3: '选择合适的位置进行安装',
    prepareWorkDesc4: '确保安装表面平整且稳固',
    installStep: '安装步骤',
    prepareBase: '准备基础',
    prepareBaseDesc: '将展架底座放置在预定位置，确保地面平整。使用水平仪检查底座是否水平。',
    assembleScaffold: '组装支架',
    assembleScaffoldDesc: '将支撑柱插入底座，按照箭头方向对齐，然后拧紧固定螺丝。确保支架垂直且稳固。',
    installShowBoard: '安装展示板',
    installShowBoardDesc: '将展示板固定在支架上，使用提供的固定件进行连接。确保展示板与支架完全对齐。',
    fixProduct: '固定产品',
    fixProductDesc: '使用提供的固定件将产品固定在展示板上。确保产品与展示板对齐，且固定牢固。',
    checkAdjust: '检查与调整',
    checkAdjustDesc: '检查产品是否与展示板对齐，确保固定牢固。如果有任何问题，请及时联系我们的客服。',
    checkAdjustList: '安装后检查清单',
    checkAdjustItem1: '所有螺丝均已拧紧',
    checkAdjustItem2: '展架稳定无晃动',
    checkAdjustItem3: '产品固定牢固',
    checkAdjustItem4: '展示角度合适',
    checkAdjustItem5: '整体外观整洁',
    replaceGuide: '替换指南',
    replaceGuideDesc: '当需要更换展示产品或维修展架时，请按照以下步骤进行操作。',
    replaceGuideDesc2: 'OpenDots 2系列更换TF卡请参考<a href="/opendots2TFcard" rel="noopener noreferrer">https://support.shokz.com/opendots2TFcard</a>',
    replaceMaterial: '替换素材',
    replaceVideo: '替换视频',
    replaceVideoDesc: '观看详细的产品替换视频教程',
    replaceVideoBtn: '观看视频',
    replaceManual: '替换手册',
    replaceManualDesc: '下载详细的产品替换说明PDF文档',
    replaceManualBtn: '下载pdf',
    replaceManualImg: '替换示意图',
    replaceManualImgDesc: '查看替换步骤的示意图',
    replaceManualImgBtn: '查看大图',

  },
  course: {
    series: '系列',
    seriesPartsTutorialDesc1: '学习如何更换POP',
    seriesPartsTutorialDesc2: '系列展架的配件，让您的展架始终保持最佳状态',
    seriesPartsTutorialDesc1OpenDots2: '学习如何更换OpenDots 2',
    seriesPartsTutorialDesc2OpenDots2: '系列展架的配件，让您的展架始终保持最佳状态',
    seriesPartsTutorial: '系列配件更换视频教程',
    clickDisplayStand: '点击下方展架卡片，观看对应的配件更换教学视频',
    selectDisplayStand: '选择展架型号',
    partsTutorial: '配件更换视频教程',
    courseDesc: '视频教程说明',
    courseDesc1: '每个视频详细展示了对应展架型号的配件更换步骤',
    courseDesc2: '视频包含完整的操作流程和安全注意事项',
    courseDesc3: '建议在更换配件前完整观看视频，确保操作正确',
    courseDesc4: '如有疑问，请联系我们的技术支持团队',
    courseTips: '更换配件前，请确保已准备好所需的替换部件和工具。建议在更换前先观看完整的视频教程。',
    courseTipsDesc1: '本视频详细展示了POP',
    courseTipsDesc2: '展架的配件更换步骤，包括试听台、试听耳机、背板画面等配件的更换方法。',
    courseTipsDesc1OpenDots2: '本视频详细展示了OpenDots 2',
    courseTipsDesc2OpenDots2: '系列展架的配件更换步骤，包括试听台、试听耳机、背板画面等配件的更换方法。',
  },
  compatible: {
    compatibleTitle1: '兼容不同的耳机',
    compatibleDesc1: '以下产品型号与我们的展示架兼容',
    compatibleTitle2: '兼容性说明',
    compatibleDesc2: '我们的展示架设计考虑了 SHOKZ 全线产品的展示需求。不同型号的展示架可能对特定产品有更好的适配性，建议根据您的产品组合选择合适的展架型号。'
  },
  feedback: {
    title: '问题反馈',
    greeting: '亲爱的用户：',
    content1: 'Shokz非常重视您的隐私，您所填的信息仅用来改进我们的产品和服务。我们将采取技术措施和其他必要措施（如匿名化处理）安全地存储这些信息。',
    content2: '我们尊重并保护您的隐私，因此未经您的明确同意，我们决不会向任何第三方出售或共享此信息。填写此问卷，即表示您同意我们在您的授权下按规定处理您的数据。如果您有任何要求，请联系我们。',
    content3: '您也可以随时前往网站首页下方查看本网站隐私政策。',
    enterBtn: '进 入',
  },
  question: {
    pageTitle: '故障排查',
    pageDesc: '常见问题及解决方案',
    problem1Title: '问题一：环形灯快速闪烁，四个按键灯不亮',
    problem1Cause1Title: '分析思路1',
    problem1Cause1Reason: '耳机未插好',
    problem1Cause1Solution1: '1. 打开试听台（操作方法参考"如何替换"内容）',
    problem1Cause1Solution2: '2. 拔下耳机 Type-C 插头并再次插上，确认连接紧固',
    problem1Cause1Solution3: '3. 观察是否恢复，恢复则End',
    problem1Cause2Title: '分析思路2',
    problem1Cause2Reason: '耳机损坏',
    problem1Cause2Solution: '请更换一个新的耳机',
    
    problem2Title: '问题二：四个按键灯快速闪烁，环形灯不亮',
    problem2Cause1Title: '分析思路1',
    problem2Cause1Reason: 'TF 卡未插好',
    problem2Cause1Solution1: '1. 打开试听台（操作方法参考"如何替换"内容）',
    problem2Cause1Solution2: '2. 拔下TF 卡并再次插上，确认连接紧固',
    problem2Cause1Solution3: '3. 观察是否恢复，恢复则End',
    problem2Cause2Title: '分析思路2',
    problem2Cause2Reason: 'TF卡损坏',
    problem2Cause2Solution: '请更换一个新的TF卡',
    
    problem3Title: '问题三：背板不亮灯，但展架可试听',
    problem3Cause1Title: '分析思路1',
    problem3Cause1Reason: '背板灯的供电线未插/接触不良',
    problem3Cause1Solution: '检查背板供电线是否插好',
    problem3Cause2Title: '分析思路2',
    problem3Cause2Reason: '使用了POP2.0的适配器（5V）',
    problem3Cause2Solution: '更换为POP3.0的适配器(12V)',
    problem3Cause3Title: '分析思路3',
    problem3Cause3Reason: '背板灯线与黑盒接触不良',
    problem3Cause3Solution: '检查背板供电线是否插好',
    problem3Cause4Title: '分析思路3',
    problem3Cause4Reason: '展架损坏',
    problem3Cause4Solution: '更换新的展架',
    
    problem4Title: '问题四：展架整个试听模块无反应',
    problem4Cause1Title: '排查思路1',
    problem4Cause1Reason: '可能是系统性短路，一般可尝试重启展架系统',
    problem4Cause1Solution1: '1. 重新拔插TF卡，观察是否恢复，恢复则End',
    problem4Cause1Solution2: '2. 重新拔插耳机，观察是否恢复，恢复则End',
    problem4Cause1Solution3: '3. 重新拔插电源，观察是否恢复，恢复则End',
    problem4Cause2Title: '排查思路2',
    problem4Cause2Reason: '按键灯线与黑盒接触不良',
    problem4Cause2Solution: '重新拔插黑盒上的按键灯线',
    problem4Cause3Title: '排查思路3',
    problem4Cause3Reason: '展架内部电路问题',
    problem4Cause3Solution: '请联系售后更换新的展架',
    
    problem5Title: '问题五：耳机无声，但按键、背板等其他模块正常',
    problem5Cause1Title: '排查思路1',
    problem5Cause1Reason: 'TF卡异常',
    problem5Cause1Solution: '更换新的TF卡',
    problem5Cause2Title: '排查思路2',
    problem5Cause2Reason: '耳机已损坏',
    problem5Cause2Solution: '更换新耳机',
    
    problem6Title: '问题六：POP耳机音量异常、声音空旷、音质差',
    problem6Cause1Title: '排查思路1',
    problem6Cause1Reason: '展架和耳机的型号错配，如S820耳机搭配S710展架',
    problem6Cause1Solution: '将耳机更换为升级小板的耳机',
    problem6Cause2Title: '排查思路2',
    problem6Cause2Reason: '耳机已损坏',
    problem6Cause2Solution: '更换新耳机',
    
    problem7Title: '问题七：更换带升级小板耳机后，耳机无声',
    problem7Reason: '带升级小板耳机未升级成功',
    problem7Solution: '耳机插入POP后升级需要一定的时间，要等四个按键灯依次亮起才算升级成功，或者等待大约1分钟',
    
    problem8Title: '问题八：耳机形变——常见于耳夹耳挂产品',
    problem8Product1: '耳挂产品：',
    problem8Product1Solution1: '轻微形变：手动矫正',
    problem8Product1Solution2: '严重形变：更换新耳机',
    problem8Product2: '耳夹产品：',
    problem8Product2Solution1: '轻微形变：手动矫正',
    problem8Product2Solution2: '严重形变：更换新耳机',
    
    causeLabel: '原因：',
    solutionLabel: '解决方案：',
    questionTitle: '无法解决问题？',
    questionDesc: '如果以上解决方案无法解决您的问题，请联系我们的技术支持团队：',
    questionPhone: '客服热线',
    questionEmail: '邮箱',
    questionOnline: '在线客服',
    questionOnlineTime: '工作日 9:00-18:00',
    questionContact: '联系时请提供以下信息：',
    questionDesc1: '展架型号和购买日期',
    questionDesc2: '问题的详细描述',
    questionDesc3: '已尝试的解决方案',
    questionDesc4: '其他相关信息（如错误提示、截图等）',
    submitBtn: '提交问题反馈',
  },
  video: {
    title: '视频播放',
    notSupported: '您的浏览器不支持视频播放',
    watchVideo: '观看视频',
    loading: '视频加载中...',
    playError: '视频播放失败，请重试',
  },
  footer: {
    support: '专业的展架用户指南和支持服务',
    quickLinks: '快速链接',
    legalInfo: '法律信息',
    privacyPolicy: '隐私政策',
    termsOfUse: '使用条款',
  },
  privacy: {
    title: 'Shokz标准陈列展架网页隐私政策',
    effectiveDate: '生效日期：【2024】年【4】月【11】日',
    intro1: '深圳市韶音科技有限公司（注册办公地址：深圳市宝安区石岩街道办社区石新社区狮子山城工业区26栋厂房一层至四层）及其关联公司（以下简称"韶音"或"我们"）致力于保护和尊重您的隐私。个人信息指以电子或其他方式记录的与已识别或可识别的自然人有关的各种信息。我们将在您使用我们的网站服务时收集、使用、披露、传输及存储您的个人信息。',
    intro2: '我们将通过本隐私政策向您说明我们收集和使用您的个人信息的目的、方式和范围，您对您的个人信息的权利，以及您向谁就我们对隐私信息安全所采取的安全保护措施。请在使用本网站、提交个人信息之前，仔细阅读本《隐私政策》，了解我们对于用户隐私的做法。',
    intro3: '本政策将帮助您了解以下内容：',
    toc1: '我们如何收集您的个人信息',
    toc2: '我们如何使用您的个人信息',
    toc3: '我们如何使用Cookie和同类技术',
    toc4: '我们如何保留您的个人信息',
    toc5: '我们如何共享、转让、公开披露您的个人信息',
    toc6: '我们如何保护您的个人信息',
    toc7: '您对个人信息的权利',
    toc8: '您的个人信息如何在全球范围内转移',
    toc9: '我们如何处理未成年人的个人信息',
    toc10: '我们隐私政策的变更',
    toc11: '留言联系信息',
    section1Title: '一、我们如何收集您的个人信息',
    section1Content1: '我们收集个人信息以便更高效的运营并为您提供优质的使用体验。我们收集个人信息的来源包括：您直接向我们提供信息和我们在您使用我们网站中我们获取的相关信息。我们收集的信息取决于您实际使用的我们的服务、您与我们互动的环境、您所做的选择、包括您的隐私设置以及您所使用的网页功能。在我们收集信息时，您并非必须向我们提供个人信息，对于部分功能，如果您选择不提供，我们可能将无法为您提供相应的服务，但不影响您使用我们网站的其他功能。',
    section1Content2: '本隐私政策适用于我们在以下情况下收集和使用的与您相关的信息：',
    section1Sub1Title: '1. 您向我们提供的信息',
    section1Sub1Content: '我们会根据您选择的服务，收集您在使用相应服务时提供的个人信息。',
    section1Sub1Example: '例如：',
    section1Sub1Item1: '（1）您通过电子邮件向我们提交的请求或提供的问题；',
    section1Sub1Item2: '（2）您参与的我们门目办或业务合作伙伴组织的问卷调查表填写；',
    section1Sub1Item3: '（3）根据您当网站服务的特点，我们可能还会在其他场景下要求您提供和收集您的个人信息，我们会在相关的服务的单独隐私权条款中向您告知。',
    contactEmail: 'privacy@shokz.com',
    contactAddress1: '深圳市韶音科技有限公司',
    contactAddress2: '广东省深圳市南山区西丽街道4221号德莱名居合楼',
    contactAddress3: '邮政编码：518017',
  }
}